import {
  APP_COLOR_SCHEME_ATTRIBUTE,
  DEFAULT_THEME_PREFERENCE,
  PREFERENCE_TO_MUI_SCHEME,
  THEME_PREFERENCE_KEY,
} from "../../styles/theme-mode-config"

export default function InitAppColorSchemeScript() {
  const preferenceKey = THEME_PREFERENCE_KEY
  const defaultPreference = DEFAULT_THEME_PREFERENCE
  const attr = APP_COLOR_SCHEME_ATTRIBUTE

  const devWarn =
    process.env.NODE_ENV !== "production"
      ? "console.warn('InitAppColorSchemeScript:', e);"
      : ""

  const script = `
    (function() {
      try {
        var pref = localStorage.getItem('${preferenceKey}') || '${defaultPreference}';
        var map = ${JSON.stringify(PREFERENCE_TO_MUI_SCHEME)};
        var scheme = map[pref];
        if (pref === 'system') {
          scheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        }
        if (scheme) {
          document.documentElement.setAttribute('${attr}', scheme);
        }
      } catch (e) {
        ${devWarn}
      }
    })();
    `

  return (
    <script
      suppressHydrationWarning
      dangerouslySetInnerHTML={{ __html: script }}
    />
  )
}
